import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface ISaveFailProps {
    closeModel: Function;
}

const SaveFail: React.FC<ISaveFailProps> = ({ closeModel }) => {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        const newContainer = document.createElement('div');
        document.body.appendChild(newContainer);
        setContainer(newContainer);

        return () => {
            document.body.removeChild(newContainer);
        };
    }, []);

    const close = () => {
        closeModel();
    };

    return container
        ? (createPortal(
              <div
                  style={{
                      position: 'absolute',
                      left: '0',
                      top: '0',
                      width: '100%',
                      height: '100%',
                      zIndex: '1000',
                      display: 'flex',
                      background: 'rgba(0,0,0,0.5)',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
              >
                  <div
                      style={{
                          position: 'relative',
                          display: 'flex',
                          width: '350px',
                          height: '400px',
                          padding: '30px 20px',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          boxSizing: 'border-box',
                          flexShrink: '0',
                          borderRadius: '25.524px',
                          background: '#FFF',
                          boxShadow: '0px 4.25402px 23.39712px 0px rgba(0, 0, 0, 0.25)',
                      }}
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="60"
                          height="60"
                          viewBox="0 0 21 22"
                          style={{ marginBottom: '24px' }}
                          fill="none"
                      >
                          <g clipPath="url(#clip0_83_233)">
                              <path
                                  d="M10 0C4.47625 0 0 4.47625 0 10C0 15.5231 4.47625 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47625 15.5231 0 10 0ZM14.7069 13.7362C14.9531 13.9788 14.9569 14.3731 14.7169 14.6212C14.4744 14.8675 14.08 14.8713 13.8319 14.6306L10 10.875L6.16813 14.6287C6.1095 14.6864 6.04005 14.7319 5.96378 14.7627C5.88751 14.7934 5.80591 14.8088 5.72368 14.808C5.64144 14.8071 5.56019 14.79 5.48459 14.7576C5.40899 14.7253 5.34052 14.6783 5.28312 14.6194C5.2255 14.5607 5.18003 14.4912 5.14933 14.4149C5.11863 14.3386 5.1033 14.257 5.10423 14.1748C5.10516 14.0926 5.12233 14.0113 5.15474 13.9357C5.18716 13.8602 5.23419 13.7917 5.29313 13.7344L9.1075 10L5.29313 6.26375C5.17485 6.1475 5.1074 5.98915 5.10552 5.82331C5.10365 5.65748 5.1675 5.49765 5.28312 5.37875C5.39946 5.26055 5.55786 5.19322 5.72369 5.19146C5.88953 5.18971 6.04931 5.25367 6.16813 5.36937L10 9.125L13.8319 5.37125C13.8905 5.31358 13.9599 5.26806 14.0362 5.23731C14.1125 5.20656 14.1941 5.19117 14.2763 5.19205C14.3586 5.19292 14.4398 5.21002 14.5154 5.24239C14.591 5.27475 14.6595 5.32173 14.7169 5.38063C14.7745 5.4393 14.82 5.50877 14.8507 5.58507C14.8814 5.66136 14.8967 5.74297 14.8958 5.8252C14.8948 5.90744 14.8777 5.98868 14.8453 6.06426C14.8128 6.13984 14.7658 6.20827 14.7069 6.26562L10.8925 10L14.7069 13.7362Z"
                                  fill="#F5222D"
                              />
                          </g>
                          <defs>
                              <clipPath id="clip0_83_233">
                                  <rect width="20" height="20" fill="white" />
                              </clipPath>
                          </defs>
                      </svg>
                      <div
                          style={{
                              color: '#000',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '20px',
                              fontStyle: 'normal',
                              fontWeight: '600',
                              lineHeight: 'normal',
                              marginBottom: '16px',
                          }}
                      >
                          保存失败
                      </div>

                      <div
                          style={{
                              color: '#000',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '18px',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '24px',
                              marginBottom: '16px',
                          }}
                      >
                          请点击保存，重新提交
                      </div>

                      <div
                          style={{
                              display: 'inline-flex',
                              padding: '10px 60px 10px 60px',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '22px',
                              background: '#5F88FF',
                              color: '#F1F1F1',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '18px',
                              fontStyle: 'normal',
                              fontWeight: '600',
                              lineHeight: 'normal',
                              cursor: 'pointer',
                          }}
                          onClick={close}
                      >
                          我知道了
                      </div>
                  </div>
              </div>,
              container,
          ) as any)
        : null;
};

export default SaveFail;
